// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FGDT","tabsBox":"styles_tabsBox__2fOBg","createButton":"styles_createButton__3N7BQ"};